import { ValidationErrorMessages } from '@constants/forms';

import { EnergyFormValues, FormErrors } from './types';

const validateForm = (
  values: EnergyFormValues,
  availableTariffTypes: string[]
) => {
  const { tariffType } = values;

  const errors: FormErrors = {};

  // Also checks against availableTariffTypes to catch stale selections — e.g.
  // Fixed remains in form state after switching to PPM, when it is no longer offered.
  if (!tariffType || !availableTariffTypes.includes(tariffType)) {
    errors.tariffType = ValidationErrorMessages.FIELD_REQUIRED;
  }

  return errors;
};

export { validateForm };
